.layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: var(--space-5);
  align-items: start;
}

.column {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}

.metaGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--space-4) var(--space-5);
}

.metaItem {
  min-width: 0;
}

.metaLabel {
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
  color: var(--text-tertiary);
  margin-bottom: var(--space-1);
}

.metaValue {
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.metaMono {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-secondary);
}

.badges {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.fileBar {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
  background: var(--bg-inset);
}

.fileName {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-primary);
  min-width: 0;
}

.fileNameText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fileMeta {
  font-size: var(--text-xs);
  color: var(--text-tertiary);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.fileActions {
  margin-left: auto;
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.signalStats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: var(--space-3);
  padding: var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
}

.signalStat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.signalLabel {
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.signalValue {
  font-family: var(--font-mono);
  font-size: var(--text-md);
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.viewerBody {
  padding: var(--space-4);
  display: grid;
  gap: var(--space-4);
}

.zoomBar {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  font-size: var(--text-xs);
  color: var(--text-tertiary);
}

.zoomSpacer {
  flex: 1;
}

.window {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}

.preview {
  margin: 0;
  padding: var(--space-4);
  background: var(--bg-inset);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  line-height: 1.65;
  color: var(--text-secondary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 260px;
  overflow: auto;
}

.formatNote {
  display: flex;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--bg-inset);
  border: 1px solid var(--border-subtle);
  font-size: var(--text-xs);
  line-height: var(--leading-relaxed);
  color: var(--text-secondary);
}

.formatIcon {
  color: var(--text-tertiary);
  flex-shrink: 0;
  margin-top: 2px;
}

.exportList {
  display: grid;
  gap: var(--space-3);
}

.exportItem {
  display: grid;
  gap: var(--space-1);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
}

.exportItem:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.exportTitle {
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-primary);
}

.exportDesc {
  font-size: var(--text-xs);
  color: var(--text-tertiary);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--space-2);
}

@media (max-width: 1080px) {
  .layout {
    grid-template-columns: minmax(0, 1fr);
  }
}
